import { Popover } from 'antd';
import { TooltipPlacement } from 'antd/es/tooltip';
import { t } from 'i18next';
import React from 'react';

import IconExclamationMark from '@/assets/icon-exclamation-mark.svg?react';

const ValidationTooltip = ({
  message,
  tArgs,
  children,
  placement,
  ...rest
}: {
  message?: string;
  tArgs?: { [x: string]: unknown };
  children: JSX.Element;
  placement?: TooltipPlacement;
  [x: string]: unknown;
}) => {
  return (
    <Popover
      open={!!message}
      placement={placement ?? 'left'}
      title={
        <>
          <IconExclamationMark />
          <span className="validation-message-title">{t(message, tArgs)}</span>
        </>
      }
      overlayStyle={{ zIndex: 1201 }}
      {...rest}
    >
      {children}
    </Popover>
  );
};

export default ValidationTooltip;
